export default "__VITE_ASSET__MxAyEnlD__"